import type { UserType } from '@econtractor/types';

interface UserAdminItemsProps {
    user: UserType;
}

const UserAdminItems = ({ user }: UserAdminItemsProps) => {
    return (
        <div className="d-flex align-items-center gap-1">
            {user.admin ? (
                <i className="bi bi-check-circle-fill fs-16 text-success"></i>
            ) : (
                <i className="bi bi-x-circle-fill fs-16 text-danger"></i>
            )}
            {!!user.userMaster && <i className="bi bi-star-fill fs-16 text-primary"></i>}
        </div>
    );
};

export default UserAdminItems;
